import React, { useState } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import {
  Text,
  Provider as PaperProvider,
  DefaultTheme,
  TextInput,
} from "react-native-paper";
import routes from "../../routing/routes";
import {
  blackColor,
  whiteColor,
  redBorderInputColor,
  redBackgroundColor,
  removeAccountColor,
} from "../../common/colors";
import Button from "../../common/Button";
import PageContainer from "../../common/PageContainer";
import { connect } from "react-redux";
import { actionCreators } from "./action";
import checker, { enumChecker } from "../../common/helpers/checker";
import ErrorEmptyNameBox from "../../common/Error/ErrorEmptyNameBox";
import MAX_WIDTH from "../../common/MaxWidth";
import t from "../../translations";

const ModalContact = (props) => {
  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  const [messageName, setMessageName] = React.useState("");
  const [messageBox, setMessageBox] = React.useState("");

  React.useEffect(() => {
    if (props.error) {
      props.saveErrorReponse(null);
    }
    return () => {
      props.saveErrorReponse(null);
    };
  }, []);

  const isNameEmpty = props.errorCode === enumChecker.emptyNameMessageBox;

  const isMessageBoxEmpty = props.errorCode === enumChecker.emptyMessageBox;

  const goToContactThankYou = () => {
    props.navigation.navigate(routes.ContactThankYou);
  };

  const onPressButton = () => {
    props.sendMessage({
      messageName,
      messageBox,
      redirect: goToContactThankYou,
    });
  };

  return (
    <PageContainer
      {...props}
      isCloseIcon={true}
      noBackground={true}
      backRoute={routes.Settings}
      maxWidth={MAX_WIDTH.AUTHENTICATION}
    >
      <View style={styles.container}>
        <View style={styles.contactToUsContainer}>
          <View style={styles.contactToUs}>
            <Text style={styles.contactToUsTitle}>{t('contact_write_to_us_title')}</Text>
          </View>
        </View>
        <View style={styles.inputsContainer}>
          <TextInput
            mode="outlined"
            label={props?.user?.user.email}
            placeholder=""
            disabled={true}
            style={styles.inputEmail}
          />
          <TextInput
            mode="outlined"
            label={t('contact_your_name_field')}
            placeholder=""
            returnKeyType="done"
            value={messageName}
            onChangeText={(text) => {
              setMessageName(text);
              isNameEmpty && props.saveErrorReponse(null);
            }}
            error={isNameEmpty && styles.inputBorderError}
            style={isNameEmpty ? styles.inputError : styles.inputYourName}
          />
          {isNameEmpty && <ErrorEmptyNameBox error={props.error} />}
          <TextInput
            mode="outlined"
            label={t('contact_write_a_message_field')}
            placeholder=""
            value={messageBox}
            right={<TextInput.Affix text="/100" />}
            onChangeText={(text) => {
              setMessageBox(text);
              isMessageBoxEmpty && props.saveErrorReponse(null);
            }}
            error={isMessageBoxEmpty && styles.inputBorderError}
            style={
              isMessageBoxEmpty ? styles.inputErrorBox : styles.inputMessageBox
            }
            returnKeyType="go"
            onSubmitEditing={onPressButton}
          />
          {isMessageBoxEmpty && <ErrorEmptyNameBox error={props.error} />}
          <View style={styles.clickToSendMessage}>
            <Button onPress={onPressButton} value={t('contact_send_button')} />
          </View>
        </View>
        <View style={styles.cancelContainer}>
          <View style={styles.cancelContent}>
            <Text
              style={styles.cancelTitle}
              onPress={() => props.navigation.navigate(routes.AboutLoriiniApp)}
            >
              {t('contact_cancel_button')}
            </Text>
          </View>
        </View>
      </View>
    </PageContainer>
  );
};

const mapStateToProps = (state) => {
  const user = state.user;
  const errorMessage =
    state.errorContactMessages && checker(state.errorContactMessages.code);
  const errorCode = state.errorContactMessages
    ? state.errorContactMessages.code
    : "";

  return { error: errorMessage, errorCode, user };
};

export default connect(mapStateToProps, actionCreators)(ModalContact);

const styles = StyleSheet.create({
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 10,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    width: "100%",
    backgroundColor: whiteColor,
  },
  container: {
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  settingsContainer: {
    alignItems: "flex-start",
    alignContent: "flex-start",
    justifyContent: "flex-start",
  },
  scrollView: {
    backgroundColor: whiteColor,
    paddingBottom: 30,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 0,
    width: "100%",
  },
  contactToUsContainer: {
    alignSelf: "flex-start",
  },
  contactToUs: {
    justifyContent: "flex-start",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-start",
    alignContent: "flex-start",
    alignSelf: "flex-start",
  },
  contactToUsTitle: {
    fontSize: 24,
    lineHeight: 26,
    letterSpacing: 1.25,
    fontWeight: "400",
    color: blackColor,
    textTransform: "uppercase",
  },
  containerButtons: {
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
  },
  inputEmail: {
    paddingTop: 0,
    paddingBottom: 24,
    backgroundColor: whiteColor,
    height: 42,
    width: "100%",
  },
  inputYourName: {
    paddingTop: 0,
    paddingBottom: 10,
    backgroundColor: whiteColor,
    height: 42,
    width: "100%",
  },
  inputMessageBox: {
    paddingTop: 0,
    paddingBottom: 10,
    backgroundColor: whiteColor,
    height: 200,
    width: "100%",
  },
  messageContent: {
    fontSize: 24,
    color: blackColor,
  },
  inputsContainer: {
    alignItems: "flex-start",
    display: "flex",
    paddingTop: 30,
    width: "100%",
  },
  cancelTitle: {
    marginTop: 35,
    marginBottom: 65,
    fontSize: 14,
    lineHeight: 16,
    letterSpacing: 0.5,
    fontWeight: "400",
    color: removeAccountColor,
    textTransform: "uppercase",
  },
  cancelContainer: {
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
  },
  cancelContent: {
    width: "100%",
  },
  clickToSendMessage: {
    alignItems: "center",
    marginBottom: 0,
    left: 0,
    right: 0,
    marginTop: 40,
    width: "100%",
  },
  inputBorderError: {
    borderColor: redBorderInputColor,
    borderWidth: 1,
    borderStyle: "solid",
  },
  inputError: {
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: redBackgroundColor,
    height: 42,
    width: "100%",
  },
  inputErrorBox: {
    paddingTop: 0,
    paddingBottom: 10,
    backgroundColor: redBackgroundColor,
    height: 200,
    width: "100%",
  },
});
